<modal [name]="localStorageKeys.ti_modal_about_this_room" [width]="950" class="room-about" (closeOut)="onClose()">
  <modal-header>
    <span>{{strings.aboutThisRoom}} - {{appVersion}}</span>
    <div class="hello-container">
      {{strings.hello}} {{userName}}
    </div>
  </modal-header>

  <modal-body>
    <ti-about-room-viewer [(isLoading)]="isLoading" [(editMode)]="showEditor" (editMode)="onEditMode($event)"></ti-about-room-viewer>
  </modal-body>

  <ng-template #help>
    <div class="container dialog-info">
      <div class="row">
        <div class="col-sm">
          <p *ngIf="needHelpText" class="help-title">{{ needHelpText }}</p>
          <p *ngIf="contactNumber"><span>{{ contactNumberText }}: </span>{{contactNumber}}</p>
        </div>
        <div class="col-sm">
          <p *ngIf="inbox && inboxText"><span>{{ inboxText }}: </span><a href="mailto:{{inbox}}@{{domainAddress}}" target="_blank" [title]="inboxText">{{inbox}}&#64;{{domainAddress}}</a></p>
          <p *ngIf="ssuInbox"><span>{{ strings.studyStartUpInbox }}: </span><a href="mailto:{{ssuInbox}}@{{domainAddress}}" target="_blank" [title]="strings.studyStartUpInbox">{{ssuInbox}}&#64;{{domainAddress}}</a></p>
          <p *ngIf="communicationInbox"><span>{{ strings.communicationInbox }}: </span><a href="mailto:{{communicationInbox}}@{{domainAddress}}" target="_blank" [title]="strings.communicationInbox">{{communicationInbox}}&#64;{{domainAddress}}</a></p>
        </div>
      </div>
    </div>
  </ng-template>

  <modal-actions *ngIf="!showEditor">
    <ng-container *ngTemplateOutlet="help"></ng-container>
    <button kendoButton fillMode="solid" themeColor="tertiary" (click)="onClose()">{{ strings.close }}</button>
  </modal-actions>

  <modal-actions *ngIf="showEditor">
    <ng-container *ngTemplateOutlet="help"></ng-container>
    <button kendoButton fillMode="solid" themeColor="tertiary" [disabled]="isLoading" (click)="cancel()">{{ strings.cancel }}</button>
    <button kendoButton fillMode="solid" themeColor="primary" [disabled]="isLoading" (click)="save()">{{ strings.save }}</button>
  </modal-actions>
</modal>
